import React from 'react';
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import MobileIcon from '../assets/img/mobile.svg';
import EyeIcon from '../assets/img/eye.svg';
import { useState } from 'react';

function LoginDan() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');


  useEffect(() => {
    const donetoken = localStorage.getItem("donetoken");
    if (donetoken) {
      navigate("/panel/home"); // اگر توکن وجود دارد، وارد پنل شود
    }
  }, [navigate]);




  const handleLogin = async () => {
    setError('');

    try {
        const response = await fetch('https://app.doneapp.ir/backend/login.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({ mobile, password }),
        });

        console.log("Response Status:", response.status);
        const text = await response.text(); // متن خام دریافتی
        console.log("Raw Response:", text);

        try {
            const data = JSON.parse(text); // بررسی درستی JSON
            console.log("Parsed Data:", data);

            if (data.status === 'success') {
                console.log("Token:", data.token);
                localStorage.setItem('donetoken', data.token);
                navigate('/panel/home');
            } else {
                setError(data.message);
            }
        } catch (jsonError) {
            console.error("Invalid JSON:", jsonError);
            setError('مشکلی در پردازش اطلاعات رخ داده است.');
        }

    } catch (err) {
        console.error("Fetch Error:", err);
        setError('مشکلی پیش آمده، لطفاً دوباره امتحان کنید.');
    }
};



  return (
    <div className="start-bdy">
      <div className="logomotion tw-200">
        <div className="start-logo">
          <img src={DanLogo} alt="Dan Logo" />
          <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
        </div>
      </div>

      <div className="loginbtns-2">
        <div className="btndiv-1">
          <div className="mobileinputdiv-1">
            <img className="mobileicon-1" src={MobileIcon} alt="Mobile Icon" />
            <input className="mobileinput-1" type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} required placeholder="شماره موبایل خود را وارد کنید" />
          </div>

          <div className="mobileinputdiv-1">
            <img className="mobileicon-1" src={EyeIcon} alt="Eye Icon" />
            <input className="mobileinput-1" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="رمز ورود خود را اینجا وارد کنید" />
          </div>

          {error && <p style={{ color: 'red' }}>{error}</p>}

          <button type="submit" className="loginbtn-1" onClick={handleLogin}>
            ورود به حساب کاربری
          </button>

          <button type="button" className="forget-btn" onClick={() => navigate("/forget")}>
            رمز عبور خود را فراموش کرده ام
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginDan;
